import * as React from 'react';
import { League, Player } from '../../../sdk/model';
import {Button} from '@mui/material';
import {isPlayerGameToday} from '../../util/PlayerDataUtil';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks';
import { useLoadLeagueData } from '../../../app/dataLoaderHooks';
import { useValidateAction } from '../../util/ActionValidationUtil';

interface bidOnPlayerButtonProps {
  leagueId : string,
  player : Player,
  teamId : string,
  fullWidth?: boolean,
  size?: 'small' | 'medium' | 'large'
}

function BidOnPlayerButton(props: bidOnPlayerButtonProps) {
  const navigate = useNavigate();
  
  const [isLoadComplete, setLoadComplete] = React.useState(false);
  const [isException, setIsException] = React.useState(false);
  
  const user = useAppSelector((state) => state.user);
  
  const league : League|undefined = useLoadLeagueData({leagueId: props.leagueId, userId: user.id, loadBasicDraftData: false,
                                                              loadFullDraftData: false, loadContractData: false,
                                                              loadBasicAuctionData: false, loadFullAuctionData: false,
                                                              loadRosterData: false, loadRosterFor: [], loadWaivedContracts: false, loadScheduleData: false,
                                                              isException: isException, setIsException: setIsException,
                                                              isLoadComplete: isLoadComplete, setLoadComplete: setLoadComplete});
  
  const canBid = useValidateAction("signFreeAgents", league);
  
  const buttonSx = {
    marginLeft: props.fullWidth ? 0 : 2,
    fontSize: { xs: '0.7rem', sm: '0.95rem' },
    padding: { xs: '4px 8px', sm: '12px 24px' },
    minHeight: { xs: '32px', sm: '48px' }
  };
  
  return isPlayerGameToday(props.player) ? 
  	<Button color="primary" variant="contained" sx={buttonSx} disabled={!canBid} fullWidth={props.fullWidth} size={props.size || 'medium'} onClick={() => navigate('/league/' + props.leagueId + '/team/' + props.teamId + '/quickSign/' + props.player.id)}>Add</Button> : 
    <Button color="primary" variant="contained" sx={buttonSx} disabled={!canBid} fullWidth={props.fullWidth} size={props.size || 'medium'} onClick={() => navigate('/league/' + props.leagueId + '/team/' + props.teamId + '/faab/' + props.player.id)}>Bid</Button>;
}

export default BidOnPlayerButton;
